import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ExecutionBodyProps, HeaderState } from "./types"
import { useCallback, useEffect, useLayoutEffect, useState } from "react"
import { questionnaire } from "../../../../utils/constants/callService"
import dayjs from "dayjs"
import { useGetData } from './hooks/getData'
import { useFilter } from "../../../../hooks/filter"
import { FilterProps } from "../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../utils/methods/removedReference"
import { Item } from "../../../../utils/types/generals"
import { ExecutionCardProps } from "./components/executionCard/types"
import { QualificationCardProps } from "./components/qualificationCard/types"
import { returnQueryWithPagination } from "../../../../utils/methods/returnQuery"
import { QuestionaireVersion, SectionData } from "../../../../service/questionarie/response"
import { formatResponse, formatVersionResponse } from "./utils/methods/formatEndpointResponseToInformation"
import {formatData, formatFilter} from "./constants/filter"
import { formatNoResponse } from "./utils/methods/noResponse"
import { useDownload } from "../../../../hooks/download/useDownload"
import { DataFlag } from "../../../../utils/enums/dataExistence"

const ExecutionBody = (props  :ExecutionBodyProps) => {
    const { id } = useParams()
    const { t } = useTranslation()
    const {noHeader, noConfig, noHeaderConfig} = formatNoResponse({t});
    const [showPettyCash, setShowPettyCash] = useState(false);
    const [config, setConfig] = useState<Array<(ExecutionCardProps | QualificationCardProps)>>(noConfig)
    const [header, setHeader] = useState<HeaderState>(noHeader)
    const [headerConfig, setHeaderConfig] = useState<{created: string, date?: dayjs.Dayjs}>({created: '', date: undefined})
    const [sections, setSections] = useState<Array<SectionData>>()
    const [flag, setFlag] = useState<boolean>(false)
    const [flagData, setFlagData] = useState<DataFlag>(DataFlag.LOADING)
    const [lastVersionId, setLastVersionId] = useState<string>(id ?? '')
    const [questionaireName, setQuestionaireName] = useState<string>('')
    const [version, setVersion] = useState<number | undefined>(undefined)
    const [versionsQuestionaire, setVersionsQuestionaire] = useState<Array<QuestionaireVersion>>([])
    const externalValidation: FilterProps['externalValidation'] = ({ name, value, body, setFilterData }) => {
      let copyBody: Record<string, any> = removeAllReference(body)

      if (copyBody?.keyCodeId) {
        copyBody = {
          ...copyBody,
          keyCodeId: (copyBody?.keyCodeId as Item[])?.map((item) => ({
            ...item,
          })),
        }
      }
      if (name === 'zoneId') {
        const newChildZone = copyBody?.childZone?.filter((e: any) => value.find((e2: any) => e2.value == e.father))
  
        handleItemsByExternal({ name: 'childZone', value: value?.length <= 0 ? [] : childZones?.filter((itemClass) => value?.some((itemZone: any) => itemZone?.value == itemClass?.father)) })
  
        setFilterData((prev) => ({
          ...prev,
          childZone: newChildZone,
        }))
  
        copyBody = {
          ...copyBody,
          childZone: newChildZone,
        }
      } else if (name === 'areas') {
        const { areas, departments: departmentsData } = copyBody
        const newDepartments = departmentsData?.filter((e: any) => areas.find((e2: any) => e2.value == e.areaId))
        let arrayChilds: any[] = []
  
        areas?.forEach((e: any) => {
          const id = e.value
          const childs = departments.filter((child) => child.areaId == id)
          arrayChilds.push(...childs)
        })
  
        handleItemsByExternal({ name: 'departments', value: arrayChilds })
        setFilterData((prev) => ({
          ...prev,
          departments: newDepartments,
        }))
  
        copyBody = {
          ...copyBody,
          departments: newDepartments,
        }
      } 
      return copyBody
    }
    const { errors, filterData,  onChange, counter, cleanFilter, query, filterString,} = useFilter( {
        externalValidation,
        formatFilter,
      } )
    const queryv2 = returnQueryWithPagination({filter: filterString,sort: query?.sort,}, formatData).replace('&','')

    const downloadMain = useDownload({
      docName: questionaireName,
      query: queryv2,
      id: lastVersionId,
      //Acá es donde debo mandar el id 
      downloadFuntion: questionnaire.downloadFile,
    })

    const downloadExtra = useDownload({
      docName: questionaireName,
      query: queryv2,
      id: lastVersionId,
      //Acá es donde debo mandar el id 
      downloadFuntion: questionnaire.downloadFileExtra,
    })
    
    const getVersionQuestionaire = async (query?:string) => {
      setFlagData(DataFlag.LOADING)
      setSections(undefined)
      const response = await questionnaire.getVersionQuestionaire({id,query})
      const {versionsQuestionaire} = formatVersionResponse({response, t, id, version})
      if(versionsQuestionaire.length===0){
        getExecutionDetalData(id,query ? queryv2:undefined)/* 
        setLastVersionId(id ?? '0') */
        setVersionsQuestionaire(versionsQuestionaire)
      }else{
        if(!version){
          setVersion(
            versionsQuestionaire[versionsQuestionaire.length-1].version
          )
        }
        setVersionsQuestionaire(versionsQuestionaire)
        setLastVersionId(
          String(versionsQuestionaire.some(item => item.questionnaireMainId === Number(lastVersionId)) ?lastVersionId:versionsQuestionaire[versionsQuestionaire.length-1].questionnaireMainId)
        )
        getExecutionDetalData(String(versionsQuestionaire.some(item => item.questionnaireMainId === Number(lastVersionId)) ?lastVersionId:versionsQuestionaire[versionsQuestionaire.length-1].questionnaireMainId),query ? queryv2:undefined)
      }
    }

    const getExecutionDetalData = async (idversion?:string, query?:string) => {
      setFlagData(DataFlag.LOADING)
      setSections(undefined) 
      const response = await questionnaire.getDetailQuestionnaireExecution({id:idversion, query:query })
      if(response.errors){ 
        setFlagData(DataFlag.NODATA);
        setHeader(noHeader)
        setConfig(noConfig)
        setSections(undefined) 
        setHeaderConfig(noHeaderConfig)
        return
      }
      if(response){
        setFlagData(DataFlag.DATA)
        const { header, config, section, headerConfig } = formatResponse({ response, t})
        const questName: string = String(header.dataHeader.quest_name)
        setQuestionaireName(questName)
        setHeaderConfig(headerConfig)
        setHeader(header)
        setSections(section)
        setConfig(config) 
      }
    }
    const { childZones, departments, input, getData, handleItemsByExternal, disabledInputs } = useGetData({counter,cleanFilter,getExecutionDetalData,queryv2,lastVersionId,getVersionQuestionaire})
    
    const getAllData = useCallback(async () => {
        getData()
      }, [])

    useEffect(() => {
        getAllData()
      }, [getAllData])

    useLayoutEffect(() => {
      /* getExecutionDetalData() */
      getVersionQuestionaire()
    }, [])

    const handleLastVersionId = ({id}:{id:string}) => {
      setLastVersionId(id);
      getExecutionDetalData(id,queryv2)
    }

    /* useLayoutEffect(() => {
      getExecutionDetalData(lastVersionId,queryv2)
    }, [lastVersionId]) */

    const handleFlag = () => {
        setFlag(!flag);
    }

    const openDrawer = () => {
      setShowPettyCash(true);
    };

    const closeDrawer = () => {
      setShowPettyCash(false);
    };

    /* const paginationMain = useFilter({
      formatFilter,
      externalValidation
    }) */

    const handleIconClick = () => {
      cleanFilter(); // Espera a que se limpie el filtro
      getVersionQuestionaire(); // Luego llama a getExecutionDetalData
    };
    return <>{props.children({ downloadExtra, downloadMain, getVersionQuestionaire, queryv2, lastVersionId, handleLastVersionId, handleIconClick, versionsQuestionaire,headerConfig, header, sections,handleFlag, flagData, flag, input, errors, filterData, onChange, t, openDrawer, closeDrawer, showPettyCash, config, counter, cleanFilter})}</>
}

export { ExecutionBody }